import { useAuthorRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetAuthorCommonInfoQuery } from "../../features/articles/articlesSlice";

export { useAuthorRoutes };

export default GetDefaultIndex({ title: "نویسندگان", query: useGetAuthorCommonInfoQuery });
